import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarProdutosFiltros = async (params) => {
  const url = `compras/produtos`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.produtos;
  }

  logout();
}

export const salvarTempoRessuprimento = async (params) => {
  const url = 'compras/produtos/tempo-ressuprimento';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const buscarInfluenciaDeProjecaoAtual = async (params) => {
  const url = 'compras/produtos/influencia-projecao';
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.influencia_projecao;
  }

  logout();
}

export const salvarInfluenciaDeProjecao = async (params) => {
  const url = 'compras/produtos/influencia-projecao';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const buscarCoberturaManualDeEstoque = async (params) => {
  const url = 'compras/produtos/cobertura-manual-estoque';
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.cobertura;
  }

  logout();
}

export const salvarCoberturaManualDeEstoque = async (params) => {
  const url = 'compras/produtos/cobertura-manual-estoque';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const salvarPrevisaoGatilho = async (params) => {
  const url = 'compras/produtos/previsao-gatilho';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}
